import { connect } from 'react-redux';
import AnnualkWhInput from './AnnualkWhInput';

import { setUtilityAnnualKWH } from '../../../common/utility/actions';

const mapStateToProps = state => ({
    isLocked: state.isLockedUI.isLocked,
    annualKWH: state.utility.annualKWH,
    setUtilityAnnualKWH,
});

const combinedActions = {
    setUtilityAnnualKWH,
};

export default connect(
    mapStateToProps,
    combinedActions,
)(AnnualkWhInput);



// WEBPACK FOOTER //
// ./src/containers/Inputs/UtilityInputs/AnnualkWhInput/index.js